module.exports = __webpack_public_path__ + "img/icons B_29.85ccf7db.png";